const menu = {
    label: '• Área',
    to: '/sol/area',
    rules: ['SOL-001'],
};

export default menu;
